import styled from 'styled-components';

export const InvoiceContainer = styled.div<{index:number}>`
position:fixed;
width:100%;
height:100vh;
display:flex;
flex-direction:column;
justify-content:center;
align-items:flex-start;
background-color: #F3F3FD;
z-index:${props=>props.index}
`;

export const InvoiceDiv = styled.div`
width:100%;
display:flex;
flex-direction:column;
justify-content:center;
align-items:center;
background-color: #F3F3FD;
`;
export const ComingSoonImg = styled.img`
width: 175.29px;
height: 73.07px;
`;

export const InvoiceImg = styled.img`
margin-top:40px;
width: 209px;
height: 142px;
`;

export const HeaderText = styled.span`
margin-top:30px;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 20px;
line-height: 140%;
color:#314259;
`;

export const IllustrationText = styled.span`
margin-top:8px;
width:267px;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 22px;
text-align: center;
color: #263345;
`;